import { render, staticRenderFns } from "./Login - 副本 (2).vue?vue&type=template&id=bd533690&scoped=true"
import script from "./Login - 副本 (2).vue?vue&type=script&lang=js"
export * from "./Login - 副本 (2).vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd533690",
  null
  
)

export default component.exports